import { Component, ElementRef, OnInit, ViewChild, inject, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BcpValidators } from '@bcp/ng-forms';
import { Subscription } from 'rxjs';
import { BcpAsyncLoader } from '@bcp/js-widgets';
import { Customer } from '../../../../domain/customer';
import { KeyboardSend } from '../../../../domain/session';
import { ModalService } from 'src/app/contexts/login/infrastructure/core/components/modal/modal.service';
import { ModalMessageFactory } from './modal-message.factory';
import { SessionStorageRepository } from 'src/app/contexts/shared/storage/session-storage.repository';
import { BcpSessionStorage } from '@bcp/js-storage';
import { CHATBOT_IDENTIFIERS, CHATBOT_STORAGE_KEY } from 'src/app/contexts/shared/constants/chatbot.constants';

@Component({
  selector: 'app-login-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormLoginComponent implements OnInit, OnChanges {
  private sessionStorageRepository = new SessionStorageRepository(new BcpSessionStorage());
  @ViewChild('pwd') inputPasswordElement!: ElementRef;
  @Output() formValue = new EventEmitter<KeyboardSend>();
  private _customer!: Customer;
   data: any = {
    seed: '',
    keys: [],
  };
  @Input()
  set customer(value: Customer) {
    this._customer = value;
    if (value?.keyboard) {
      this.data = {
        seed: this.customer.keyboard.seed,
        keys: this.customer.keyboard.keys,
      }
    }
  }

  get customer(): Customer {
    return this._customer;
  }

  @Input() showWarning = false;
  @Input() errorCount = 0;

  private readonly modalService = inject(ModalService);
  private readonly asyncLoader = inject(BcpAsyncLoader);
  private modalMessageFactory = new ModalMessageFactory();
  private subscription = new Subscription();
  visible = false;
  passwordControl = new FormControl<KeyboardSend>({ keys: [], seed: '' }, [BcpValidators.required, BcpValidators.lengthInputPassword(6)]);

  stateError?: string;

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['errorCount']?.currentValue > 0) this.openModalToAttemp();
  }

  
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  openModalToCreatePassword() {
    const chatbotId = this.sessionStorageRepository.find(CHATBOT_STORAGE_KEY) ?? CHATBOT_IDENTIFIERS.AS_IS;
    this.modalService.open(this.modalMessageFactory.createPassword(chatbotId), 0);
  }

  openModalToForgotPassword() {
    const chatbotId = this.sessionStorageRepository.find(CHATBOT_STORAGE_KEY) ?? CHATBOT_IDENTIFIERS.AS_IS;
    this.modalService.open(this.modalMessageFactory.forgotPassword(chatbotId), 0);
  }

  openModalToLastAttemp() {
    this.modalService.open(this.modalMessageFactory.lastAttemp(), 240);
  }

  openModalToAttemp() {
    this.modalService.open(this.modalMessageFactory.attemp(), 255);
  }

  reset() {
    this.passwordControl.reset();
  }

  closeWarning() {
    this.showWarning = false;
  }

  sendForm() {
    this.showWarning = false;
    if (this.isValidForm()) {
      this.formValue.emit(this.passwordControl.value!);
      this.reset();
    }
  }

  isValidForm() {
    return this.passwordControl.valid;
  }

  ctrlFocus() {
    this.reset();
  }
}
